import {classes, DOMAttrs, m} from '@codeurs/front'
import {FunctionComponent, useEffect, useRef} from 'react'
import {render} from 'react-dom'
import {useNavigate} from 'react-router'
import {isDonwloadableFile} from 'util/string'
import {FloatProp, ImagePopup} from 'views/blocks/imageblock'

const getOrigin = loc =>
  loc.protocol + '//' + loc.hostname + (loc.port ? ':' + loc.port : '')

const isExternal = anchorElement =>
  getOrigin(location) !== getOrigin(anchorElement)

const click = (navigate, e) => {
  if (
    e.defaultPrevented ||
    e.button !== 0 ||
    e.altKey ||
    e.metaKey ||
    e.ctrlKey ||
    e.shiftKey ||
    e.currentTarget.target === '_blank' ||
    isExternal(e.currentTarget)
  )
    return
  e.preventDefault()
  const href = e.currentTarget.getAttribute('href')
  navigate(href)
}

export const Trusted: FunctionComponent<
  {
    children: string
  } & DOMAttrs
> = ({children, class: c1, className: c2}) => {
  const navigate = useNavigate()
  const el = useRef<HTMLDivElement>()
  useEffect(() => {
    const dom = el.current
    const clear = []
    const listener = click.bind(null, navigate)
    for (const a of dom.querySelectorAll('a')) {
      a.classList.add('wysiwyg-link')
      const href = a.getAttribute('href')

      if (href && isDonwloadableFile(href) === true) {
        a.classList.add('mod-file')
        a.setAttribute('target', '_blank')
      }

      if (href && href.indexOf('#') === 0) return null

      if (checkIfPresentationLink(href)) a.classList.add('mod-presentation')
      // if (checkIfLegacLink(href)) return

      a.addEventListener('click', listener)
      clear.push(() => a.removeEventListener('click', listener))
    }

    for (const img of dom.querySelectorAll('img')) {
      const {alt, width, height, className} = img as HTMLImageElement
      const a = img.closest('a')
      if (a) continue
      const container = document.createElement('div')
      img.replaceWith(container)

      const imgFloat = img.style.cssFloat as FloatProp

      requestAnimationFrame(() => {
        render(
          <ImagePopup
            image_center={false}
            image={{
              alt,
              src: img.getAttribute('src'),
              width,
              height,
              class: className
            }}
            image_float={imgFloat as FloatProp}
          />,
          container
        )
      })
      clear.push(() => render(null, container))
    }

    return () => {
      clear.forEach(f => f())
    }
  }, [])

  return (
    <div
      ref={el}
      {...classes(c1, c2)}
      dangerouslySetInnerHTML={{
        __html: cleanWysiwyg(Array.isArray(children) ? children[0] : children)
      }}
    />
  )
}

const cleanWysiwyg = text => {
  if (!text) return null
  return text
    .replace('<table', '<div class="theme_wysiwyg-table-container"><table')
    .replace('</table>', '</table></div>')
    .replace('<a href="/en/', '<a href="/')
}

const checkIfPresentationLink = href => {
  if (!href) return false
  return href.includes('youtube') || href.includes('youtu.be')
}
